module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/414.1cf6e553.png";